import i18n from '../../../../../../i18n';
import {
  LanguageNew,
  LanguageStringMapNew,
} from '../../../../../../types/Common';

export const getModalLangTabs = (value: LanguageStringMapNew) => {
  const nlValue = Object.keys(value).find((k) => k.includes('nl'));
  const frValue = Object.keys(value).find((k) => k.includes('fr'));
  const deValue = Object.keys(value).find((k) => k.includes('de'));
  return [
    {
      label: i18n.t('English'),
      value: 'en' as LanguageNew,
    },
    {
      label: i18n.t('Dutch'),
      value: nlValue as LanguageNew,
    },
    {
      label: i18n.t('French'),
      value: frValue as LanguageNew,
    },
    {
      label: i18n.t('GERMAN'),
      value: deValue as LanguageNew,
    },
  ];
};
